// extracted by mini-css-extract-plugin
export default {"paleSky":"#667085","valueMeasurement":"styles_valueMeasurement__GQZ02"};